import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize fbq queue manually (mirrors FB's snippet without DOM lookup)
    // @ts-ignore
    const n: any = function (...args: any[]) {
      // @ts-ignore
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // @ts-ignore
    window.fbq = n;
    // @ts-ignore
    window._fbq = n;
    // Safely inject the FB events script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // @ts-ignore
    window.fbq('init', '1252242806993118');
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-97">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1252242806993118&ev=PageView&noscript=1" alt="" data-id="element-98" />
    </noscript>;
}